module.exports = __webpack_public_path__ + "static/Instagram-9c720864ef843df60c021cee826bfcd9.jpg";